import styled from '@emotion/styled';
import { device, typography, Reveal, standardTable } from '@landsbankinn/ui';
import React from 'react';

export const HeadingText = styled.h2`
  ${typography.p2}
  margin-bottom:60px;
  padding: 0px 20px;
`;
const Host = styled(Reveal)`
  ${standardTable('Gray', true)}

  width: 100%;
  padding: 0px 20px;
  table {
    table-layout: fixed;
  }
  & > h2 {
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    font-family: ${(props) => props.theme.font.familySlab};
    margin-bottom: 30px;
  }

  table thead th {
    border-bottom: 3px solid ${(props) => props.theme.colors.primary};
    padding-bottom: 10px;
    text-align: right;
    font-family: ${(props) => props.theme.font.family};
    font-size: 14px;

    padding-left: 0px;
    @media ${device.tablet} {
      font-size: ${typography.sizes.bodySmallSize}px;
      padding-left: 0;
      min-width: 100px;
    }
    &:nth-child(1) {
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      font-family: ${(props) => props.theme.font.family};
      width: 250px;
      &:after {
        display: none;
      }
    }
    @media ${device.tablet} {
      &:nth-child(1) {
        font-size: 18px;
        font-weight: 500;
        text-align: left;
        font-family: ${(props) => props.theme.font.familySlab};
        &:after {
          display: none;
        }
      }
    }
  }
  table tbody tr {
    > td {
      border-bottom: 1px solid rgba(30, 61, 90, 0.1);
      padding-top: 10px;
      padding-bottom: 3px;
      text-align: right;
      width: 25%;
    }
    &:first-child {
      td {
        padding-top: 20px;
      }
    }
  }
  table tbody tr:last-child td {
    border-color: rgba(30, 61, 90, 0.1);
    padding-bottom: 3px;
  }
  > div > div > table {
    width: ${(props) => props.theme.pageWidth}px;
  }
  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    border-bottom: 1px solid ${(props) => props.theme.colors.primary};
    font-family: ${(props) => props.theme.font.family};

    @media ${device.tablet} {
      font-size: 14px;
    }
  }

  tr > td:nth-child(1) {
    text-align: left;
  }

  tfoot td {
    border: 0;
    font-size: ${typography.sizes.bodySmallSize}px;
    padding-top: 11px;
    font-family: ${(props) => props.theme.font.family};
    font-weight: 600;
    text-align: right;
    &:nth-child(1) {
      text-align: left;
    }
  }
`;

interface IProps {
  children: React.ReactNode;
}

export function TableWithLargeText({ children }: IProps) {
  return <Host>{children}</Host>;
}
